import { render } from "./List.vue?vue&type=template&id=d5ef3824"
import script from "./List.vue?vue&type=script&lang=js"
export * from "./List.vue?vue&type=script&lang=js"

import "./List.vue?vue&type=style&index=0&id=d5ef3824&lang=scss"

import exportComponent from "/proyectos/programas-de-investigacion/scga-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__